module.exports = __webpack_public_path__ + "img/time.ac3c36d6.svg";